import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Import from the main branded file
import { NICKLE_LOGO, COLORS, formatCurrency, drawRoundedRect, drawFooter } from './pdfExportBranded';

// Redesigned House Calculator PDF matching CI mockup
export const exportHouseCalculatorToPDF = (netSalary, results, inputs) => {
  if (!results || !results.affordableHousePrice) {
    console.error('Invalid results object');
    alert('Unable to export PDF: Calculation results are not available.');
    return;
  }
  
  const doc = new jsPDF();
  
  // Logo and header
  try {
    doc.addImage(NICKLE_LOGO, 'PNG', 15, 15, 25, 25);
  } catch (e) {
    console.log('Logo not added');
  }
  
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.darkGreen);
  doc.text('Nickle', 45, 27);
  
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...COLORS.gray);
  doc.text('Smart Budgets Meet Big Ambitions', 45, 34);
  
  // Title section (top right)
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.black);
  doc.text('Home Affordability Calculator', 195, 22, { align: 'right' });
  
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  doc.text('Generated by Nickle', 195, 28, { align: 'right' });
  doc.text(new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }), 195, 33, { align: 'right' });
  
  let yPos = 55;
  
  // HERO RESULT
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...COLORS.gray);
  doc.text('You can afford a home worth', 105, yPos, { align: 'center' });
  
  yPos += 10;
  doc.setFontSize(32);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.darkGreen);
  doc.text(formatCurrency(results.affordableHousePrice), 105, yPos, { align: 'center' });
  
  yPos += 8;
  drawRoundedRect(doc, 82, yPos, 46, 7, COLORS.turquoise);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Within Budget', 105, yPos + 5, { align: 'center' });
  
  yPos += 18;
  
  // SIDE-BY-SIDE CARDS
  const cardWidth = 87;
  const cardGap = 6;
  const leftX = 15;
  const rightX = leftX + cardWidth + cardGap;
  
  // MONTHLY COSTS CARD (Left)
  drawRoundedRect(doc, leftX, yPos, cardWidth, 8, COLORS.orange);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Monthly Costs', leftX + 3, yPos + 5.5);
  
  yPos += 12;
  const monthlyY = yPos;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  doc.text('Car Payment', leftX + 3, yPos);
  doc.text(formatCurrency(results.monthlyRepayment), leftX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Insurance', leftX + 3, yPos);
  doc.text(formatCurrency(inputs.insurance || 0), leftX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Fuel', leftX + 3, yPos);
  doc.text(formatCurrency(inputs.maintenance || 0), leftX + cardWidth - 3, yPos, { align: 'right' });
  
  // UPFRONT COSTS CARD (Right - same yPos as Monthly)
  yPos = monthlyY - 12;
  drawRoundedRect(doc, rightX, yPos, cardWidth, 8, COLORS.blue);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Upfront Costs', rightX + 3, yPos + 5.5);
  
  yPos += 12;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  doc.text('Down Payment', rightX + 3, yPos);
  doc.text(formatCurrency(results.downPayment), rightX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Transfer Duty', rightX + 3, yPos);
  doc.text(formatCurrency(results.transferDuty), rightX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Bond Registration', rightX + 3, yPos);
  doc.text(formatCurrency(results.bondRegistration), rightX + cardWidth - 3, yPos, { align: 'right' });
  
  yPos += 15;
  
  // LOAN DETAILS CARD (Full width)
  drawRoundedRect(doc, 15, yPos, 180, 8, COLORS.gray);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Loan Details', 18, yPos + 5.5);
  
  yPos += 12;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  const col1X = 18;
  const col2X = 105;
  
  doc.text('Budget for Car', col1X, yPos);
  doc.text(`${inputs.budgetPercentage || 30}%`, col1X + 40, yPos);
  
  doc.text('Loan Term Car', col2X, yPos);
  doc.text(`${(inputs.loanTerm || 240) / 12} years`, col2X + 40, yPos);
  
  yPos += 5;
  doc.text('Interest Rate', col1X, yPos);
  doc.text(`${inputs.interestRate || 11.5}%`, col1X + 40, yPos);
  
  // Footer
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.text('Smart Budgets Meet Big Ambitions', 105, 280, { align: 'center' });
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.turquoise);
  doc.text('www.nickle.com', 105, 287, { align: 'center' });
  
  doc.save('Nickle-House-Affordability-Report.pdf');
};

// Redesigned Car Calculator PDF matching CI mockup
export const exportCarCalculatorToPDF = (netSalary, results, inputs) => {
  if (!results || !results.affordableCarPrice) {
    console.error('Invalid results object');
    alert('Unable to export PDF: Calculation results are not available.');
    return;
  }
  
  const doc = new jsPDF();
  
  // Logo and header
  try {
    doc.addImage(NICKLE_LOGO, 'PNG', 15, 15, 25, 25);
  } catch (e) {
    console.log('Logo not added');
  }
  
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.darkGreen);
  doc.text('Nickle', 45, 27);
  
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...COLORS.gray);
  doc.text('Smart Budgets Meet Big Ambitions', 45, 34);
  
  // Title section (top right)
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.black);
  doc.text('Car Affordability Calculator', 195, 22, { align: 'right' });
  
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  doc.text('Generated by Nickle', 195, 28, { align: 'right' });
  doc.text(new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }), 195, 33, { align: 'right' });
  
  let yPos = 55;
  
  // HERO RESULT
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...COLORS.gray);
  doc.text('You can afford a car worth', 105, yPos, { align: 'center' });
  
  yPos += 10;
  doc.setFontSize(32);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.blue);
  doc.text(formatCurrency(results.affordableCarPrice), 105, yPos, { align: 'center' });
  
  yPos += 8;
  drawRoundedRect(doc, 82, yPos, 46, 7, COLORS.turquoise);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Within Budget', 105, yPos + 5, { align: 'center' });
  
  yPos += 18;
  
  // SIDE-BY-SIDE CARDS
  const cardWidth = 87;
  const cardGap = 6;
  const leftX = 15;
  const rightX = leftX + cardWidth + cardGap;
  
  // MONTHLY COSTS CARD (Left)
  drawRoundedRect(doc, leftX, yPos, cardWidth, 8, COLORS.orange);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Monthly Costs', leftX + 3, yPos + 5.5);
  
  yPos += 12;
  const monthlyY = yPos;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  doc.text('Car Payment', leftX + 3, yPos);
  doc.text(formatCurrency(results.monthlyRepayment), leftX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Insurance', leftX + 3, yPos);
  doc.text(formatCurrency(inputs.insurance || 0), leftX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Fuel', leftX + 3, yPos);
  doc.text(formatCurrency(inputs.petrol || 0), leftX + cardWidth - 3, yPos, { align: 'right' });
  
  // UPFRONT COSTS CARD (Right - same yPos as Monthly)
  yPos = monthlyY - 12;
  drawRoundedRect(doc, rightX, yPos, cardWidth, 8, COLORS.blue);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Upfront Costs', rightX + 3, yPos + 5.5);
  
  yPos += 12;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  doc.text('Down Payment', rightX + 3, yPos);
  doc.text(formatCurrency(results.downPayment || 0), rightX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('On-Road Costs', rightX + 3, yPos);
  doc.text(formatCurrency(results.onRoadCosts || 0), rightX + cardWidth - 3, yPos, { align: 'right' });
  yPos += 5;
  
  doc.text('Service Plan', rightX + 3, yPos);
  doc.text(`${inputs.servicePlanPercentage || 10}%`, rightX + cardWidth - 3, yPos, { align: 'right' });
  
  yPos += 15;
  
  // LOAN DETAILS CARD (Full width)
  drawRoundedRect(doc, 15, yPos, 180, 8, COLORS.gray);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(255, 255, 255);
  doc.text('Loan Details', 18, yPos + 5.5);
  
  yPos += 12;
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.setFont('helvetica', 'normal');
  
  const col1X = 18;
  const col2X = 105;
  
  doc.text('Budget for Car', col1X, yPos);
  doc.text(`${inputs.budgetPercentage || 35}%`, col1X + 40, yPos);
  
  doc.text('Loan Term Car', col2X, yPos);
  doc.text(`${(inputs.loanTerm || 60) / 12} years`, col2X + 40, yPos);
  
  yPos += 5;
  doc.text('Interest Rate', col1X, yPos);
  doc.text(`${inputs.interestRate || 10.5}%`, col1X + 40, yPos);
  
  // Footer
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.gray);
  doc.text('Smart Budgets Meet Big Ambitions', 105, 280, { align: 'center' });
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...COLORS.turquoise);
  doc.text('www.nickle.com', 105, 287, { align: 'center' });
  
  doc.save('Nickle-Car-Affordability-Report.pdf');
};
